import React from 'react';
import { forNamespace } from 'app/common/lib/util/i18n';
import styles from './TeamfulCollaborationSuccessMessage.less';
import { useTeamfulCollaborationSuccessMessageQuery } from '@trello/graphql/generated';
import {
  Button,
  ButtonSizes,
  ButtonTypes,
} from 'app/common/components/controls/button/button';
import { IconName } from 'app/common/components/controls/icon';
import { UpgradePromptFull } from 'app/src/components/UpgradePrompts/UpgradePromptFull';
import { Noun, Verb, trackUe } from '@trello/analytics';

const format = forNamespace('teamful collaboration prompt');

interface TeamfulCollaborationSuccessMessageProps {
  onClose: () => void;
  orgId: string;
}

const upgradePromptCTATrackEvent = () => {
  trackUe({
    category: Noun.TEAM_PAGE,
    verb: Verb.OPENS,
    directObj: Noun.TEAM_PAGE_BC_TAB,
    method:
      'by clicking full upgrade prompt in the teamless collaboration prompt',
  });
};

export const TeamfulCollaborationSuccessMessage: React.FunctionComponent<TeamfulCollaborationSuccessMessageProps> = ({
  onClose,
  orgId,
}) => {
  const { data } = useTeamfulCollaborationSuccessMessageQuery({
    variables: { orgId },
  });
  const orgName = data && data.organization && data.organization.name;

  return (
    <div className={styles.successMessage}>
      <UpgradePromptFull
        content={format(['upgrade prompt', 'content'])}
        cta={format(['upgrade prompt', 'cta'])}
        ctaLink={`${orgName}/billing`}
        ctaTrackEvent={upgradePromptCTATrackEvent}
        headline={format(['upgrade prompt', 'headline'])}
        iconName={IconName.BusinessClass}
      />
      <Button
        buttonType={ButtonTypes.PRIMARY}
        className={styles.successMessageButton}
        onClick={onClose}
        size={ButtonSizes.FULLWIDTH}
      >
        {format(['success', 'dismiss'])}
      </Button>
    </div>
  );
};
